import * as buffer from "buffer";
window.Buffer = buffer.Buffer;
import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from "react-error-boundary";
import './theme/main.scss'
import 'react-modern-drawer/dist/index.css'
import "react-datepicker/dist/react-datepicker.css";
// import { useSampleStore } from './store/sampleStore'
import { router } from './Routing';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect } from "react";
import { useAuthStore } from "./store/authStore";
import { refreshToken } from "./utils/fetchUtils";
export const queryClient = new QueryClient()

window.__TANSTACK_QUERY_CLIENT__ = queryClient

function App() {
  const { nextRefreshTime, refresh_token } = useAuthStore()

  useEffect(() => {
    const fullUrl = window.location.origin;
    let title = 'Business'
    switch (fullUrl) {
      case 'https://business.centivo.dev':
        title += ` (dev)`
        break;
      case 'https://business.centivo.live':
        title += ` (live)`
        break;
      case 'https://business.centivo.com':
        title += ` (prod)`
        break;
      default:
        title += ` (local)`
        break;
    }
    document.title = title
  }, []);

  //NOTE auto refresh token in every 9 minutes
  // useEffect(() => {
  //   if (!refresh_token) return;

  //   const refreshInterval = setInterval(async () => {
  //     await refreshToken();
  //   }, nextRefreshTime || 9 * 60 * 1000); // Refresh every 9 minutes

  //   // Refresh when user returns to tab (handles throttled setInterval when tab was backgrounded)
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       refreshToken();
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     clearInterval(refreshInterval);
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, [refresh_token, nextRefreshTime]);

  const logError = (error, info) => {
    console.log(error, info)
  };

  return (
    <div className="App">
      <ErrorBoundary
        FallbackComponent={Fallback}
        onError={logError}
        onReset={(details) => {
          // Reset the state of your app so the error doesn't happen again
        }}
      >
        <QueryClientProvider client={queryClient}>
          <ToastContainer />
          <RouterProvider router={router} />
          {/* <br />
        <p>State management example</p>
        {count}
        <button onClick={() => increase()}>increate</button> */}
        </QueryClientProvider>
      </ErrorBoundary>
    </div>
  )
}

export default App


function Fallback({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
}